
 export enum RxType {
     er = "Edit Rx", //for Edit Rx 
     rf = "Refill Rx",           // for Refill Flow
     nr = "New Rx",   // New Rx
     enr = "eRx to New Rx"   // New Rx
 }
 export enum DeleteRxFrmScreens {
    browseRx = 6,
    returnToStock = 2,
    editRx = 3,
    rxHistory = 5,
    transmissionScreen = 4
 }
export enum SignatureType
{
    Pickup = 1,
    Payment = 2,
    HIPAA = 3

}
 export enum RxTransferEnums {
    Fax = 1
 }
 export enum PickupSource {
    PrimePosCloud = 1,
    PrimePosEnterprise = 2,
    MyPrimeRx = 3
 }
 export enum FaxMessageType {
    RefillRequest = 'Refill Request',
    HistoryReport = 'Rx History',
    RejectedReport = 'Rejected Transmission',
    TransferOutReport = 'Transfer Out'
}

export enum ErxMessageType {
    CancelRxResponse = 5,
    RxChangeResponse = 6
}